import _default from './Popup';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/modules/Popup/index.js
// module id = 670
// module chunks = 0